import _ from 'lodash';

import api from '../../api';
import worldMap from '../../core/map';
import translate from '../../core/tools/translate';
import environment from '../../environment';
import layers from '../../layers';
import { NOTIFY_TYPE, notify } from '../../shared';
import { CoreControl } from '../CoreControl';
import { VectorType } from '../VectorType';

const LayerControls = (name) => require('..').get(name);

export class StoreAreasAfterSalesControl extends CoreControl {
    constructor() {
        super({ name: 'StoreAreasAfterSales' });

        this.getLayer = this.getLayer.bind(this);
        this.purge = this.purge.bind(this);
        this.select = this.select.bind(this);
        this.toggleAll = this.toggleAll.bind(this);

        this._lastStoreId = 0;
    }

    static getInstance() {
        if (!StoreAreasAfterSalesControl._instance) {
            StoreAreasAfterSalesControl._instance = new StoreAreasAfterSalesControl();
        }

        return StoreAreasAfterSalesControl._instance;
    }

    init() {
        const _dataSource = [
            { text: translate('Common.Área de Influência'), value: 'TradeArea' },
            { text: '2 KM Buffer', value: 'BufferArea' }
        ];

        const values = {
            disabled: true,
            help: translate(`Help.${this.options.name}`),
            id: 'layer-tradearea',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            purge: this.purge,
            type: 'vector-layers',
            dropdown: [{
                name: 'list',
                dataSource: _dataSource,
                change: this.select
            }],
            checkbox: {}
        };

        values.checkbox[translate('Action.LoadFromAllVisibleStores')] = {
            name: 'loadFromAllVisibleStores',
            change: this.toggleAll,
            value: ''
        };

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    getLayer(currentMap = worldMap.getCurrent(), name = this._getSelectedLayer()) {
        return layers.get(name, currentMap);
    }

    toggleAll(checked) {
        if (!checked) { return; }

        this.check(true);

        const currentMap = worldMap.getCurrent();
        const areas = _(this.getLayer(currentMap, this._getSelectedLayer()).getCurrentFeatures()).map(f => f.properties.IdLoja).uniq().value();
        const dealershipsLayer = this.getLayer(worldMap.getCurrent(), 'Dealerships');
        const competitorsLayer = this.getLayer(worldMap.getCurrent(), 'Competitors');
        const storesOnMap = [
            ...dealershipsLayer.visible() ? dealershipsLayer.getCurrentFeatures() : [],
            ...competitorsLayer.visible() ? competitorsLayer.getCurrentFeatures() : []
        ];

        if (storesOnMap.length > 100) {
            notify(NOTIFY_TYPE.LOG, 'Limite de requisições simultâneas para essa funcionalidade é de até 100.');
            return;
        }

        const stores = _(storesOnMap)
            .map(f => f.properties.Id)
            .filter(storeId => !_.some(areas, id => storeId === id))
            .value();

        if (_.size(stores)) {
            this.setValue(stores, currentMap);
        }
    }

    add(feature, currentMap = worldMap.getCurrent(), context) {
        this.setValue(feature.properties.Id, currentMap);
        if (!feature.properties.PossuiServiceArea) {
            if (this.getControls(currentMap._id).dropdown.list.value === 'TradeArea' && context) {
                LayerControls(context).show({
                    show: true,
                    tab: 'summary',
                    id: feature.properties.Id
                });
            }
        }
    }

    remove(feature, currentMap = worldMap.getCurrent()) {
        const layer = this.getLayer(currentMap, this._getSelectedLayer());

        if (this.getControls(currentMap._id).dropdown.list.value === 'TradeArea') {
            _.forEach(_.range(1, 4), i => layer.removeLayer(`${feature.properties.Id}${i}`, false));
        } else {
            layer.removeLayer(feature.properties.Id, false);
        }

        if (this.check() && this.getLayer().visible()) {
            layer.reload();
        }
    }

    purge(currentMap = worldMap.getCurrent()) {
        if (this.check() && this.getLayer().visible()) {
            this.getLayer(currentMap, this._getSelectedLayer()).clear(true);
        }
    }

    setLayer(name, currentMap = worldMap.getCurrent()) {
        // hide all layers
        this.getControls().dropdown.list.input.dataItems().forEach((val) => {
            const layer = this.getLayer(currentMap, val.value);

            if (layer) {
                layer.hide();
            }
        });

        if (this.check()) {
            const layer = this.getLayer(currentMap, this._getSelectedLayer());

            try {
                layer.show();
            } catch (err) {
                // layer is not present in the map
                layer.reload();
            }

            if (this.getControls(currentMap._id).checkbox.loadFromAllVisibleStores.status) {
                this.toggleAll(true);
            } else {
                this.setValue(this._lastStoreId);
            }
        }
    }

    // END: setLayer = (name) ->
    setValue(stores, currentMap = worldMap.getCurrent(), autoReload = true) {
        const layer = this.getLayer(currentMap, this._getSelectedLayer());

        if (typeof stores === 'number') {
            stores = [stores];
        }

        this._lastStoreId = stores[stores.length - 1];

        const url = this.getControls(currentMap._id).dropdown.list.value === 'TradeArea'
            ? `${environment.get('API_HOST')}/lojaconcessionaria/tradeareas`
            : `${environment.get('API_HOST')}/loja/ObterBufferArea`;

        const queue = [];

        _.forEach(stores, id => {
            queue.push(api.fetch({
                type: 'GET',
                url,
                data: {
                    IdLoja: id
                }
            }));
        });

        Promise.all(queue.map((promise, i) =>
            promise.catch(err => {
                err.index = i;
                return err;
            })))
            .then((res) => {
                _.forEach(res, (featureCollection, index) => {
                    if (_.isArray(featureCollection.features)) {
                        _.forEach(featureCollection.features, feature => {
                            feature.properties.IdLoja = stores[index];
                        });

                        layer.setFeatures(featureCollection);
                    }
                });

                if (autoReload) {
                    layer.reload();
                }
            });
    }

    select() {
        this.setLayer();
    }

    _getSelectedLayer() {
        try {
            return this.getControls(worldMap.getCurrent()._id).dropdown.list.value;
        } catch (err) {
            console.log('ERROR', err);
            return undefined;
        }
    }
}

export default StoreAreasAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/StoreAreasAfterSalesControl.js